import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import autorunAbi from "../abi/autorun.json";
import ownerAbi from "../abi/owner.json";
import bankAbi from "../abi/bank.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import tokenAbi from "../abi/token.json";
import { ethers } from "ethers";

// Polygon Mainnet
const proxyContract = "0x12eb4DAAA39C2A171283C3BF823Dcf95eaAd6220";
const autoRunProxy = "0xd61597041C0E053ed237174Da4a2688a6c11F62e";
const ownerContract = "0xc7EcabEF6a21c5f7D3A3Ffa06da37D2CAFfE1671";
const bankContract = "0xEb9638024A74c66e9698668A5310C6838Fc42D11";

// Amoy
// const proxyContract = "0xbA1F6fE6ef201cb9704D177868E28F51B014C7D5";
// const autoRunProxy = "0x6901450A8c8b489ae62FB824460DA805F443609a";
// const ownerContract = "0x5d8a65D07aaB33f1E3d11ecfA8B7B890E7b11df6";
// const bankContract = "0x8100F2e6F301c54066e53f8b7080b2b4107Bf1cF";

// local
// const proxyContract = "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0";
// const autoRunProxy = "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9";
// const ownerContract = "0x75537828f2ce51be7289709686A69CbFDbB714F1";
// const bankContract = "0x0165878A594ca255338adfa4d48449f69242Eb8F";

const contractCreationBlockNumber = 36878957;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    
    return contract;
}

export const getBankContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(bankContract, bankAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRunContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRunProxy, autorunAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getContractCreationBlock = async () => {
    return contractCreationBlockNumber;
}

export const getTotalContractTransactions = async () => {
    try {
      const wallet = await getWallet();
      const transactionCount = await wallet.provider.getTransactionCount(proxyContract);
      console.log("transactionCount: ", transactionCount);
      return transactionCount;
    } catch (error) {
      throw new Error('Failed to retrieve total contract transactions: ' + error.message);
    }
  };

// export const getAutoLpContract = async () => {
//     const wallet = await getWallet();
//     let contract = new ethers.Contract(autoLp, autolp, wallet.provider);
//     if (!wallet.isReadOnly) {
//         contract = contract.connect(wallet.signer);
//     }
//     return contract;
// }

export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

const token = "0xD69071579ae36c45D63EC2D5d0E82C0a569c2cC3";

export const getTokenContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(token, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  return contract;
}


export default getContract;